import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfile } from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { baseURL, baseURLImg } from "../../Services/api_endpoints";

const Header = () => {
  const navigate = useNavigate();
  const location = window.location.pathname;
  const token = useSelector((state) => JSON.parse(state.auth.token));
  const [userDetails, setUserDetails] = useState(null);

  const handleGetProfile = async () => {
    try {
      const res = await getProfile(token);
      console.log(res);
      if (res.status === 200) {
        setUserDetails(res.data.data.user);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetProfile();
  }, []);
  return (
    <div
      className="fixed z-[999] w-full"
      style={{
        top: "12px",
        left: 0,
        padding: "0 20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          minHeight: "68px",
          background: "linear-gradient(100deg, #d9f2fb, #ffffff 50%, #d9f2fb)",
          border: "1px solid rgba(148, 205, 226, 0.55)",
          borderRadius: "18px",
          boxShadow: "0 8px 28px rgba(38, 91, 120, 0.13)",
          padding: "12px 22px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        {/* Brand */}
        <p
          onClick={() => navigate(location === "/" ? "/" : "/dashboard")}
          style={{
            fontSize: "clamp(17px, 2vw, 24px)",
            fontWeight: "800",
            color: "#163a59",
            cursor: "pointer",
            margin: 0,
            whiteSpace: "nowrap",
            letterSpacing: "-0.5px",
          }}
        >
          Swasthya Khata <span style={{ color: "#2586c7" }}>Admin</span>
        </p>

        {location !== "/" && (
          <>
            {/* Navigation */}
            <nav
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                flex: "1 1 auto",
                minWidth: 0,
                overflowX: "auto",
                scrollbarWidth: "none",
              }}
            >
              {[
                { label: "Hospitals", path: "/hospitals" },
                { label: "Diagnostic", path: "/diagonistics" },
                { label: "Doctors", path: "/doctors" },
              ].map((item) => {
                const active = location === item.path;

                return (
                  <button
                    key={item.path}
                    type="button"
                    onClick={() => navigate(item.path)}
                    style={{
                      padding: "10px 14px",
                      borderRadius: "10px",
                      border: active
                        ? "1px solid #c5e7fa"
                        : "1px solid transparent",
                      backgroundColor: active ? "#e8f5ff" : "transparent",
                      color: active ? "#1769a6" : "#536779",
                      fontSize: "14px",
                      fontWeight: active ? "700" : "600",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      transition: "all 0.2s ease",
                      flexShrink: 0,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e8f5ff";
                      e.currentTarget.style.color = "#1769a6";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = active
                        ? "#e8f5ff"
                        : "transparent";
                      e.currentTarget.style.color = active
                        ? "#1769a6"
                        : "#536779";
                    }}
                  >
                    {item.label}
                  </button>
                );
              })}
            </nav>
 </>
        )}
            {/* Profile */}
            <button
              type="button"
              onClick={() => navigate("/profile")}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "9px",
                padding: "7px 12px 7px 7px",
                borderRadius: "12px",
                border: "1px solid #b9ddf5",
                backgroundColor: "#2479c5",
                color: "#ffffff",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                flexShrink: 0,
                maxWidth: "180px",
              }}
            >
              <img
                src={
                  userDetails?.profile_image
                    ? `https://admin-service.swasthyakhata.com${userDetails.profile_image}`
                    : "/Assets/user-1.png"
                }
                alt="Profile"
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid rgba(255,255,255,0.8)",
                  flexShrink: 0,
                }}
              />

              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {userDetails?.first_name || "Profile"}
              </span>
            </button>
         
      </div>

      {/* Responsive styles */}
      <style>{`
    @media (max-width: 640px) {
      .header-unused {
        display: none;
      }
    }

    @media (max-width: 640px) {
      /* Keep the brand and profile on the first row */
    }
  `}</style>
    </div>
  );
};

export default Header;
